<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="data.data.length > 0">
        <b-table class="border-top-0 mb-0" :items="data.data" :fields="fields" striped >
          <template v-slot:cell(gateway)="data">
            <gateway :gateway="data.value" />
          </template>
          <template v-slot:cell(appVersion)="data">
            {{data.item.userDevice.appVersion}}
          </template>
          <template v-slot:cell(carrier)="data">
            {{data.item.userDevice.carrier}}
          </template>
          <template v-slot:cell(platform)="data">
            {{data.item.userDevice.device.platform}}
          </template>
          <template v-slot:cell(createdAt)="data">
            {{ data.value | moment("MMMM Do YYYY") }}
          </template>
          <template v-slot:cell(action)="row">
            <b-button size="sm" variant="danger" v-b-modal="String(row.item.id)">Delete</b-button>
            <b-modal :id="String(row.item.id)" title="Delete Session" @ok="() => deleteSession(row.item.id)">
              <p class="my-4">Confirmation</p>
            </b-modal>
          </template>

          <template v-slot:row-details="row">
            <b-card>
              <div class="row">
                <div class="col-lg-6">
                  <dl class="row">
                    <dt class="col-sm-3">Brand: </dt>
                    <dd class="col-sm-9">{{row.item.userDevice.device.brand}}</dd>
                    <dt class="col-sm-3">Model: </dt>
                    <dd class="col-sm-9">{{row.item.userDevice.device.model}}</dd>
                    <dt class="col-sm-3">OS Version: </dt>
                    <dd class="col-sm-9">{{row.item.userDevice.device.osVersion}}</dd>
                    <dt class="col-sm-3">Created: </dt>
                    <dd class="col-sm-9">{{row.item.userDevice.device.createdAt | moment("MMMM Do YYYY")}}</dd>
                  </dl>
                </div>
                <div class="col-lg-6">
                  <dl class="row">
                    <dt class="col-sm-5">Platform: </dt>
                    <dd class="col-sm-7">{{row.item.userDevice.device.platform}}</dd>
                    <dt class="col-sm-5">is Emulator: </dt>
                    <dd class="col-sm-7">{{row.item.userDevice.device.isEmulator}}</dd>
                    <dt class="col-sm-5">is Tablet: </dt>
                    <dd class="col-sm-7">{{row.item.userDevice.device.isTablet}}</dd>
                    <dt class="col-sm-5">is Rooted: </dt>
                    <dd class="col-sm-7">{{row.item.userDevice.device.isRooted}}</dd>
                  </dl>
                </div>
              </div>
            </b-card>
          </template>
        </b-table>

      </div>
      <div class="text-center m-3" v-else>
        <h5 class="card-title">Search Result</h5>
        <p class="card-text">No Data</p>
      </div>

    </div>
  </div>
</template>

<script>
import GetUserSessions from '../../../../store/actions/getUserSessions';
import DeleteSession from '../../../../store/actions/deleteSession';
import ShowError from "../../../../helpers/showError";
import ContentLoader from '../../../../components/ContentLoader';
import GatewayRender from '../../../../components/GatewayRender';

export default {
  name: 'UserSessions',
  components: {
    loader: ContentLoader,
    gateway: GatewayRender,
  },
  data(){
    return {
      loading: false,
      data: [],
      fields: ['gateway', 'appVersion', 'carrier', 'platform', 'createdAt', 'action']
    }
  },
  created() {
    this.getSessions();
  },
  methods: {
    async getSessions(){
      try {
        this.loading = true;
        let result = await GetUserSessions(this.$route.params.id);
        result.data = result.data.map(item => {
          item._showDetails = true;
          return item
        });
        this.data = result;
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    },
    async deleteSession(id) {
      try {
        this.loading = true;
        await DeleteSession(id);
        this.getSessions();
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
